export const accordionData = [
    {
      heading: "Information om GDPR",
      content:
        "Nordic Spells Decor AB lagrar dina personuppgifter såsom namn, mejl, mobilnummer och vid fakturering även adress i syfte att: Du skall kunna få bekräftelser samt information från oss. Vi skall kunna kontakta dig som kund. Vi ska kunna skicka faktura till dig som kund. Vi raderar dina personuppgifter om det inte är aktuellt att anlita/hyra av oss alternativt efter slutfakturan är betald. Om du vill återta samtycke tidigare ber vi dig kontakta oss via nordicspellsdecor@gmail.com.",
    },
  ];